export const authorizedUser = (res) => {
    if (res?.code === 440) {
      localStorage.clear("p");
      window.location.href = `/auth/login?error=Your session has expired`;
    } else {
      return;
    }
  };